/**
 * Integration for Select2
 * 
 * Imports Select2, configures Translations and applies our patches
 *
 */

import $ from 'jquery';

import Select2 from 'select2/src/js/jquery.select2';

import en from 'select2/src/js/select2/i18n/en';
import de from 'select2/src/js/select2/i18n/de';

import Translation from 'select2/src/js/select2/translation';
import Defaults from 'select2/src/js/select2/defaults';

import 'libs/select2patches';


// load Select2 languages as its internal loader will not work
Object.entries({
    "en": en,
    "de": de,
}).forEach(entry => {
    const [lang, translations] = entry;
    Translation._cache[Defaults.defaults.amdLanguageBase+lang] = Translation._cache[lang] = translations;
});

// deactivate select2's language loader and fallback to english
Translation.loadPath = function (path) {
    if (!(path in Translation._cache)) {
        return new Translation(Translation._cache["en"]);
    }
    return new Translation(Translation._cache[path]);
}

// Allow other Select2 versions to be present by deactivating "our" jQuery.fn.select2
if ($.fn.selectWoo === $.fn.select2) {
    // only reset it if it is really "our" Select2
    $.fn.select2 = undefined;
}

/**
 * @description
 * @class Select2Isolated
 * @extends {Select2}
 */
class Select2Isolated extends Select2 {
    constructor($element, options) {
        super($element, options);

        // replace the hidden-accessible class with our custom class to avoid conflicts with Plone's Select2 v3.5
        $element[0].classList.remove('select2-hidden-accessible');
        $element[0].classList.add('tud-select2-hidden-accessible');

        // redirect the select2 function on our instance to selectWoo as we deactivated our jQuery.fn.select2
        $element.select2 = $.fn.selectWoo.bind($element);
    }

    destroy() {
        Select2.prototype.destroy.call(this);

        // remove our custom hidden-accessible class
        this.$element[0].classList.remove('tud-select2-hidden-accessible');
    }
}

export default Select2Isolated;